module.exports = __webpack_public_path__ + "static/media/Honesty.30451fba.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Honesty.svg
// module id = 305
// module chunks = 0